var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"_TagBtnRemove-inner _px025 _radius"},[_vm._v("×")])}
var staticRenderFns = []

export { render, staticRenderFns }